import Grid from "@mui/material/Grid";
import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";

const StatsItem = (props: any) => {
  const { title, data } = props;

  return (
    <Grid
      className="statsCard"
      item
      xs
      sx={{
        borderRight: `1px solid ${tokens.Border.General.Secondary}`,
        paddingY: "12px",
        "&.MuiGrid-item.statsCard": {
          "&:last-child": { marginRight: "0", border: "none" }
        }
      }}
    >
      <Typography variant="h2" showBold color={tokens.Text.General.Secondary} sx={{ textAlign: "center" }}>
        {data}
      </Typography>
      <Typography
        variant="label"
        color={tokens.Text.General.Secondary}
        sx={{ textAlign: "center", display: "block", fontSize: "12px", paddingX: "8px" }}
      >
        {title}
      </Typography>
    </Grid>
  );
};

export default StatsItem;
